import React from "react";
import styled from "styled-components";
import { Card } from "antd";

const SectionCard = ({
  title,
  children,
  extra,
  className = "section-card",
  ...props
}) => {
  return (
    <StyledSectionCard className={className} {...props}>
      {title && (
        <div className="card-header">
          <h3 className="card-title">{title}</h3>
          {extra && <div className="card-extra">{extra}</div>}
        </div>
      )}
      <div className="card-body">{children}</div>
    </StyledSectionCard>
  );
};

const StyledSectionCard = styled(Card)`
  border-radius: 20px;
  border: 2px solid var(--color-border-light);
  box-shadow: 0 8px 32px rgba(44, 95, 45, 0.08);
  background: white;
  margin-bottom: 2rem;
  overflow: hidden;

  @media (max-width: 768px) {
    border-radius: 16px;
    margin-bottom: 1.5rem;
  }

  .card-header {
    background: var(--color-primary) !important;
    border-bottom: 2px solid var(--color-border-light);
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .card-title {
    padding: 1.5rem 2rem 1rem 2rem;
    font-family: var(--font-primary);
    font-size: 1.5rem;
    font-weight: 700;
    color: white !important;
    margin: 0;
    text-align: center;
    flex: 1;

    @media (max-width: 768px) {
      font-size: 1.25rem;
      padding: 1.25rem 1.5rem 0.875rem 1.5rem;
    }
  }

  .card-extra {
    padding: 1.5rem 2rem 1rem 0;
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;

    @media (max-width: 768px) {
      padding: 1.25rem 1rem 0.875rem 0;
    }
  }

  .card-body {
    padding: 2rem;

    @media (max-width: 768px) {
      padding: 1.5rem 1rem;
    }

    /* Fix pagination alignment */
    .ant-pagination {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5rem;
    }

    .ant-pagination-total-text {
      display: flex;
      align-items: center;
      height: 32px;
      line-height: 32px;
    }

    .ant-pagination-item,
    .ant-pagination-prev,
    .ant-pagination-next {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      min-width: 32px;
      line-height: 32px;
    }

    .ant-pagination-options {
      display: flex;
      align-items: center;
      height: 32px;
      margin-left: 0;
      position: relative;
      z-index: 1;

      .ant-select {
        display: flex;
        align-items: center;
        height: 32px;
        position: relative;
        z-index: 100;
      }

      .ant-select-selector {
        display: flex;
        align-items: center;
        height: 32px !important;
        padding: 0 11px;
      }

      .ant-select-selection-item {
        display: flex;
        align-items: center;
        line-height: 32px;
        height: 32px;
      }

      .ant-select-arrow {
        display: flex;
        align-items: center;
        top: 50%;
        transform: translateY(-50%);
        margin-top: 0 !important;
      }
    }

    /* Prevent table scroll when pagination dropdown is open */
    .ant-table-pagination {
      position: relative;
      z-index: 10;
    }

    /* Prevent table body from scrolling when pagination dropdown opens */
    .ant-table-body {
      scroll-behavior: auto !important;
      overflow-anchor: none !important;
    }

    /* Prevent scroll on table container */
    .ant-table-container {
      scroll-behavior: auto !important;
      overflow-anchor: none !important;
    }
  }

  &.section-card {
    background: #ffffff !important;
    border: 2px solid #e2e8f0 !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(44, 95, 45, 0.08) !important;
    margin-bottom: 2rem !important;
    overflow: hidden !important;
  }

  .ant-card-body {
    padding: 0px !important;
  }
`;

export default SectionCard;
